<template>
  <div class="container visitReportAudit">
    <div class="searchBox">
      <div class="searchBox_top">
        <template v-if="showButton">
          <el-button type="primary" @click="pass()">{{$t('visitPlan.ApprovalPass')}}</el-button>
          <el-button type="primary" @click="refuseVisible = true">{{$t('visitPlan.ApprovalReject')}}</el-button>
        </template>
        <el-button type="primary" @click="goBack">{{$t('common.close')}}</el-button>
        <!--关闭-->
      </div>
    </div>

    <el-tabs v-model="activeName">
      <el-tab-pane label="报告明细" name="first">
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span>MSV Basic Info</span>
          </div>
          <el-form :model="queryCondition" inline label-width="240px">
            <el-form-item label="MSV 单据编号" prop="msvNo">
              <!--计划单据编号-->
              <el-input v-model="queryCondition.msvNo" disabled></el-input>
            </el-form-item>
            <el-form-item :label="$t('visitPlan.Year')" prop="year">
              <!--拜访年份-->
              <el-input v-model="queryCondition.year" disabled></el-input>
            </el-form-item>
            <el-form-item :label="$t('visitPlan.Type')" prop="type">
              <!--供应商类型-->
              <el-select v-model="queryCondition.type" disabled>
                <el-option :key="index" v-for="(item,index) in typeList" :label="item.chineseValue" :value="item.code"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="Category" prop="category">
              <!--类型-->
              <el-select v-model="queryCondition.category" disabled>
                <el-option :key="index" v-for="(item,index) in categoryList" :label="item.chineseValue" :value="item.code"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('visitPlan.SupplierFacility')" prop="plantName">
              <!--供应商工厂-->
              <el-input disabled v-model="queryCondition.plantName"></el-input>
              <!-- <el-input v-model="queryCondition.tmSupplierId" disabled></el-input> -->
            </el-form-item>
            <el-form-item label="Report by" prop="createBy">
              <el-input v-model="createBy" disabled></el-input>
            </el-form-item>
            <el-form-item :label="$t('visitPlan.CreateDate')" prop="dataArr">
              <!--创建时间-->
              <el-date-picker value-format="yyyy-MM-dd" type="date" v-model="queryCondition.createDate" placeholder="选择日期" disabled></el-date-picker>
            </el-form-item>
            <el-form-item label="Visit Type" prop="visitType">
              <el-select v-model="queryCondition.visitType" disabled>
                <el-option :key="index" v-for="(item,index) in visitTypeList" :label="item.chineseValue" :value="item.code"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="Report to（Supplier)" prop="supplierEmail">
              <el-input v-model="queryCondition.supplierEmail" disabled type="textarea" :rows="3"></el-input>
            </el-form-item>
            <el-form-item label="Report (McD)" prop="mcdEmail">
              <el-input v-model="queryCondition.mcdEmail" disabled type="textarea" :rows="3"></el-input>
            </el-form-item>
            <el-form-item label="Attendees Supplier" prop="attendeesSupplier">
              <el-input v-model="queryCondition.attendeesSupplier" disabled type="textarea" :rows="3"></el-input>
            </el-form-item>
            <el-form-item width="200" label="Attendees McDonald’s(& On behalf)" prop="attendeesMcd">
              <el-input v-model="queryCondition.attendeesMcd" disabled type="textarea" :rows="3"></el-input>
            </el-form-item>
            <el-form-item label="Mgt. recap" prop="mgtRecap">
              <el-select v-model="queryCondition.mgtRecap" disabled>
                <el-option :key="index" v-for="(item,index) in mgtRecapList" :label="item.chineseValue" :value="item.code"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="MSV Result" prop="msvResult">
              <el-select v-model="queryCondition.msvResult" disabled>
                <el-option :key="index" v-for="(item,index) in msvResultList" :label="item.chineseValue" :value="item.code"></el-option>
              </el-select>
            </el-form-item>
            <el-row>
              <el-form-item label="On-site observations Number"></el-form-item>
            </el-row>
            <el-row>
              <el-form-item label="High Risk" prop="highScore" class="highScoreClass">
                <el-input v-model="queryCondition.highScore" clearable disabled></el-input>
              </el-form-item>
              <el-form-item label="Medium Risk" prop="mediumScore" class="ScoreClass">
                <el-input v-model="queryCondition.mediumScore" clearable disabled></el-input>
              </el-form-item>
              <el-form-item label="Low Risk" prop="lowScore" class="ScoreClass">
                <el-input v-model="queryCondition.lowScore" clearable disabled></el-input>
              </el-form-item>
            </el-row>
            <el-form-item label="CAP Implementation  Status" prop="capImplementationStatus">
              <el-select v-model="queryCondition.capImplementationStatus" disabled>
                <el-option :key="index" v-for="(item,index) in capImplementationStatusList" :label="item.chineseValue" :value="item.code"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('visitPlan.VisitDate')" prop="dataArr">
              <el-date-picker v-model="dataArr" type="daterange" :range-separator="$t('common.to')" :start-placeholder="$t('common.startDate')" :end-placeholder="$t('common.endDate')" disabled></el-date-picker>
            </el-form-item>
          </el-form>

          <el-table :data="tableList" ref="tableList" border fit class="purposeList">
            <el-table-column type="selection" width="50"></el-table-column>
            <el-table-column type="index" label="序号" width="50"></el-table-column>
            <el-table-column show-overflow-tooltip prop="visitPurpose" :label="$t('visitPlan.visitPurpose')">
              <template slot-scope="scope">
                <el-autocomplete class="inline-input" v-model="scope.row.visitPurpose" :fetch-suggestions="querySearch" disabled placeholder="请输入内容">
                </el-autocomplete>
              </template>
            </el-table-column>
          </el-table>
        </el-card>
        <el-card class="box-card" style="margin-top:20px">
          <div slot="header" class="clearfix">
            <span>附件</span>
          </div>
          <el-table :data="fileList" border highlight-current-row class="table">
            <el-table-column show-overflow-tooltip sortable prop="documentName" :label="$t('common.file')" min-width="130px">
              <template slot-scope="scope">
                <el-link type="primary" @click.native="downloadFileFDP(scope.row)">{{scope.row.documentName}}</el-link>
              </template>
            </el-table-column>
          </el-table>
        </el-card>
      </el-tab-pane>
      <el-tab-pane :label="$t('common.approvalLog')" name="second">
        <el-table :data="approvalList" border fit>
          <el-table-column show-overflow-tooltip prop="createDate" :label="$t('common.OperationTime') ">
            <template slot-scope="scope">{{scope.row.createDate | dateFormatFilter("YYYY-MM-DD HH:mm:ss")}}</template>
          </el-table-column>
          <el-table-column show-overflow-tooltip prop="operatorName" :label="$t('common.OperatorName') "></el-table-column>
          <el-table-column show-overflow-tooltip prop="action" :label="$t('common.PedagogicalOperation') "></el-table-column>
          <el-table-column show-overflow-tooltip prop="comments" :label="$t('common.remarks') "></el-table-column>
        </el-table>
      </el-tab-pane>
    </el-tabs>
    <el-dialog title="审批拒绝" :visible.sync="refuseVisible">
      <el-form :model="refuseForm" ref="refuseForm" :rules="refuseFormRules" inline>
        <el-form-item label="请填写拒绝原因 " label-width="120" prop="comments">
          <el-input v-model="refuseForm.comments" maxlength="300"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="refuseVisible = false" type="primary">取 消</el-button>
        <el-button type="primary" @click="refuse('refuseForm')">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  approvalPass,
  approvalRefuse,
  getVisitReportList,
  addVisitPlanReportInit,
  reportDetail,
  getCategoryValue,
  getAuditLogs
} from "@/api/visitPlan.js";
import { fileService } from "../../../api/common/file-utils";
import { inputChoiceService } from "../../../api/common/input-choice";
import commonFunction from "../../../utils/dataTableUtils";

import { Message } from "element-ui";
export default {
  name: "",
  components: {},
  data() {
    return {
      approvalList: [],
      showButton: true,
      refuseForm: {
        comments: ""
      },
      ttMsvReportId: "",
      uploadFileList: [],
      activeName: "first",
      dataArr: [],
      totalCount: 0,
      tableList: [],
      riskLevelList: "",
      queryCondition: { pageSize: 15, pageNum: 1 },
      addPlanDetailsForm: {
        type: "Food"
      },
      refuseFormRules: {
        comments: [
          {
            required: true,
            message: "不能为空",
            trigger: "blur"
          }
        ]
      },
      refuseVisible: false,
      showAccessories: false,
      rows: [],
      Categorylevel: true,
      typeList: [],
      categoryList: [],
      visitTypeList: [],
      mgtRecapList: [],
      msvResultList: [],
      visitPurposeList: [],
      addPlanDetailsTable: [],
      capImplementationStatusList: [],
      //弹框中的字段
      detailAddform: { pageSize: 15, pageNum: 1, categoryLevel1Name: "Food" },
      tableList2: [],
      showFileList: [],
      fileList: []
    };
  },
  computed: {
    selection() {
      return this.$refs.table.selection;
    }
  },
  created() {
    this.createBy = localStorage.getItem("ms_userCd");
    this.ttMsvReportId = this.$route.query.ttMsvReportId;
    this.getDetail(this.$route.query.ttMsvReportId);
    this.getInputChoiceValues();
    this.getFiles();
    this.getAuditLogsList(this.$route.query.ttMsvReportId);
  },
  methods: {
    getAuditLogsList(id) {
      getAuditLogs(id).then(res => {
        this.approvalList = res.data.logs;
        console.log(res);
      });
    },
    querySearch(queryString, cb) {
      var restaurants = this.visitPurposeList;
      restaurants = restaurants.map(obj => {
        return {
          ...obj,
          value: obj.chineseValue
        };
      });
      var results = queryString
        ? restaurants.filter(this.createFilter(queryString))
        : restaurants;
      cb(results);
    },
    createFilter(queryString) {
      return restaurant => {
        return (
          restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) ===
          0
        );
      };
    },
    //文件下载
    downloadFile: function (row) {
      fileService.downloadFile(row).then(res => { });
    },
    downloadFileFDP: function (row) {
      console.log(row)
      fileService.downloadFileFDP(row, row.tmDocumentId, this.ttMsvReportId).then(res => { });
    },
    //文件删除
    deleteFile: function (tmDocumentId, index, files) {
      fileService.deleteFile(tmDocumentId).then(res => {
        //删除成功删除列表数据
        files.splice(index, 1);
      });
    },
    removeFile: function (file, fileList) {
      this.uploadFileList = [];
      fileList.forEach(file => {
        this.uploadFileList.push(file.raw);
      });
    },
    init() {
      let that = this;
      getVisitReportList(that.queryCondition).then(res => {
        console.log(res);
        let list = res.resultData;
        for (let i = 0, len = list.length; i < len; i++) {
          list[i].ids = i;
        }
        this.tableList = list;
      });
      addVisitPlanReportInit().then(res => {
        // this.$set(that.queryCondition.msv, "msvNo", res.data);
        that.queryCondition.msvNo = res.data;
      });
    },
    //获取MSV_REPOR_CQS文件列表数据获取
    getFiles: function () {
      let attachment = {};
      attachment.seq = "1";
      attachment.tsRecId = this.ttMsvReportId;
      attachment.tsReckindId = "MSV_REPOR_CQS";
      fileService.getFileList(attachment).then(fileRes => {
        this.fileList = fileRes;
      });
    },
    getDetail(id) {
      let that = this;
      reportDetail(id).then(res => {
        console.log(res);
        let list = res.data.msvReportDetails;
        for (let i = 0, len = list.length; i < len; i++) {
          list[i].ids = i;
        }
        that.tableList = list;
        that.queryCondition.msvNo = res.data.msvNo;
        that.queryCondition.year = res.data.year;
        that.queryCondition.type = res.data.type;
        that.queryCondition.supplierCode = res.data.supplierCode;
        that.queryCondition.createBy = res.data.createBy;
        that.queryCondition.createDate = res.data.createDate;
        that.queryCondition.visitType = res.data.visitType;
        that.queryCondition.supplierEmail = res.data.supplierEmail;
        that.queryCondition.mcdEmail = res.data.mcdEmail;
        that.queryCondition.attendeesSupplier = res.data.attendeesSupplier;
        that.queryCondition.attendeesMcd = res.data.attendeesMcd;
        that.queryCondition.mgtRecap = res.data.mgtRecap;
        that.queryCondition.msvResult = res.data.msvResult;
        that.queryCondition.highScore = res.data.highScore;
        that.queryCondition.mediumScore = res.data.mediumScore;
        that.queryCondition.capImplementationStatus =
          res.data.capImplementationStatus;
        that.queryCondition.lowScore = res.data.lowScore;
        that.queryCondition.plantName = res.data.plantName;
        that.queryCondition.capImplementationStatus =
          res.data.capImplementationStatus;
        that.queryCondition.category = res.data.category;
        if (res.data.visitBeginDate != null) {
          that.$set(
            that.queryCondition,
            "visitBeginDate",
            this.$options.filters["dateFormatFilter"](res.data.visitBeginDate)
          );
          that.$set(
            that.queryCondition,
            "visitEndDate",
            this.$options.filters["dateFormatFilter"](res.data.visitEndDate)
          );
          that.dataArr = [
            this.$options.filters["dateFormatFilter"](res.data.visitBeginDate),
            this.$options.filters["dateFormatFilter"](res.data.visitEndDate)
          ];
        }
        that.createBy = res.data.creater;
        if (res.data.type == "Food") {
          this.istypeFood = true;
          that.getCategory("Food");
        }
        let status = res.data.status;
        if (status == "COMPLETED") {
          that.showButton = false;
        }
      });
    },
    //动态获取Category下拉框的值
    getCategory(value) {
      let that = this;
      let data = {
        categoryLevel1Name: value
      };
      getCategoryValue(data).then(res => {
        this.categoryList = res.data;
      });
    },
    //审批通过
    pass() {
      let that = this;
      let data = {
        auditFlag: "COMPLETE",
        ttMsvReportId: that.ttMsvReportId
      };
      approvalPass(data).then(res => {
        if (res.meta.success) {
          that.$message({
            message: that.$t("common.ApprovalPass"),
            type: "success"
          });
          that.$router.go(-1);
        }
      });
    },
    refuse(refuseForm) {
      let that = this;
      this.$refs.refuseForm.validate(valid => {
        if (valid) {
          that.refuseVisible = false;
          let data = {
            auditFlag: "REJECT",
            comments: that.refuseForm.comments,
            ttMsvReportId: that.ttMsvReportId
          };
          console.log(data);
          approvalRefuse(data).then(res => {
            if (res.meta.success) {
              that.$message({
                message: that.$t("common.ApprovalReject"),
                type: "success"
              });
              that.$router.go(-1);
            }
          });
        } else {
          return false;
        }
      });
    },
    goBack() {
      window.history.go(-1);
    },
    getInputChoiceValues() {
      let mapObj = {};
      mapObj["TT_MSV:RISK_LEVEL"] = "TT_MSV:RISK_LEVEL";
      mapObj["TT_MSV:TYPE"] = "TT_MSV:TYPE";
      mapObj["TT_MSV:VISIT_TYPE"] = "TT_MSV:VISIT_TYPE";
      mapObj["TT_MSV:CAP_IMPLEMENTATION_STATUS"] =
        "TT_MSV:CAP_IMPLEMENTATION_STATUS";
      mapObj["TT_MSV:RECAP"] = "TT_MSV:RECAP";
      mapObj["TT_MSV:RESULT"] = "TT_MSV:RESULT";
      mapObj["TT_MSV:VISITPURPOSE"] = "TT_MSV:VISITPURPOSE";
      mapObj["TT_MSV:CATEGORYTYPE"] = "TT_MSV:CATEGORYTYPE";
      inputChoiceService.getInputChoiceValues(mapObj).then(res => {
        this.typeList = res["TT_MSV:TYPE"];
        this.riskLevelList = res["TT_MSV:RISK_LEVEL"];
        this.visitTypeList = res["TT_MSV:VISIT_TYPE"];
        this.capImplementationStatusList =
          res["TT_MSV:CAP_IMPLEMENTATION_STATUS"];
        this.mgtRecapList = res["TT_MSV:RECAP"];
        this.msvResultList = res["TT_MSV:RESULT"];
        this.visitPurposeList = res["TT_MSV:VISITPURPOSE"];
        this.categoryList = res["TT_MSV:CATEGORYTYPE"];
        // this.restaurant  = res["TT_MSV:VISITPURPOSE"];
        // console.log(this.restaurant)
      });
    }
  },
  extends: commonFunction
};
</script>
<style scoped  lang="scss">
.el-table {
  margin-top: 10px;
}
.searchBox_top {
  margin-bottom: 20px;
}
.tip {
  color: #1f2f3d;
  margin-bottom: 5px;
  display: block;
}
.tipText span {
  color: #8492a6;
  font-size: 14px;
  display: block;
}
</style>
<style lang="scss">
.visitReportAudit {
  .el-form-item__content {
    width: 220px;
  }
  .el-date-editor {
    width: 100%;
  }
  .el-select {
    width: 100%;
  }
  .purposeList {
    .el-table__row {
      td:nth-child(3) {
        .cell {
          width: 100%;
          .el-autocomplete {
            width: 100%;
          }
        }
      }
    }
  }
  .ScoreClass {
    width: 280px;
    .el-form-item__content {
      width: 150px;
    }
    .el-form-item__label {
      width: 110px !important;
    }
  }
  .highScoreClass {
    width: 420px;
    .el-form-item__content {
      width: 150px;
    }
  }
}
</style>

